import {
    Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel,
    Box,
    Button,
    Card,
    Flex,
    Grid, GridItem,
    Heading,
    IconButton, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Select, Skeleton, Stack, SimpleGrid,
    Text,
    Textarea, useDisclosure,
    useToast,
    Badge,
    Icon
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
    addBulkAnswers,
    addNewGoal,
    addNewObjectives,
    completeIEPStep,
    deleteQuestionGoal, deleteQuestionObjectives, onGetHistory
} from "../../http/iepAPis";
import { MdAdd, MdHistory, MdDelete } from "react-icons/md";
import CoustomAlertDialog from "../../components/CoustomAlertDialog";
import { canAddStudent } from "../../utils/common";
import { BrandButton, GhostButton } from "../../components/TablePageShell";

const ObjectiveForm = ({
    o,
    index,
    isCompleted,
    bulkAnswers,
    iepId,
    t,
    setIsDelete,
    onOpen,
    onGetVersionHistory,
    onOpenHistory,
    handleChange
}) => (
    <AccordionItem border="1px solid" borderColor="gray.200" borderRadius="lg" mb={3} bg="gray.50" overflow="hidden">
        <h2>
            <AccordionButton _expanded={{ bg: 'blue.50', color: 'blue.700' }} py={3}>
                <Box as="span" flex='1' textAlign='left' fontWeight="bold" fontSize="md">
                    Objective {index} {bulkAnswers.get(o.objectiveQuestionId)?.content ? `: ${bulkAnswers.get(o.objectiveQuestionId).content.substring(0, 60)}${bulkAnswers.get(o.objectiveQuestionId).content.length > 60 ? '...' : ''}` : ''}
                </Box>
                <AccordionIcon />
            </AccordionButton>
        </h2>
        <AccordionPanel pb={4} bg="white">
            <Flex direction={{ base: 'column', md: 'row' }} gap={4} align="flex-start">
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} flex={1} w="100%">
                    <Box>
                        <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">{t('objectives')}</Text>
                        <Textarea
                            bg="white"
                            fontSize="md"
                            minH="150px"
                            isDisabled={isCompleted || !canAddStudent()}
                            _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                            value={bulkAnswers.get(o.objectiveQuestionId) ? bulkAnswers.get(o.objectiveQuestionId).content : ''}
                            onChange={(e) => {
                                const obj = {
                                    "questionId": o.objectiveQuestionId,
                                    "iepId": iepId,
                                    "type": 'TEXT',
                                    "content": e.target.value,
                                    "remarks": ""
                                };
                                handleChange(o.objectiveQuestionId, obj)
                            }}
                        />
                    </Box>
                    <Box>
                        <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">{t('activities')}</Text>
                        <Textarea
                            bg="white"
                            fontSize="md"
                            minH="150px"
                            isDisabled={isCompleted || !canAddStudent()}
                            _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                            value={bulkAnswers.get(o.activityQuestionId) ? bulkAnswers.get(o.activityQuestionId).content : ''}
                            onChange={(e) => {
                                const obj = {
                                    "questionId": o.activityQuestionId,
                                    "iepId": iepId,
                                    "type": 'TEXT',
                                    "content": e.target.value,
                                    "remarks": ""
                                };
                                handleChange(o.activityQuestionId, obj)
                            }}
                        />
                    </Box>
                    <Box>
                        <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">{t('materials')}</Text>
                        <Textarea
                            bg="white"
                            fontSize="md"
                            minH="150px"
                            isDisabled={isCompleted || !canAddStudent()}
                            _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                            value={bulkAnswers.get(o.materialQuestionId) ? bulkAnswers.get(o.materialQuestionId).content : ''}
                            onChange={(e) => {
                                const obj = {
                                    "questionId": o.materialQuestionId,
                                    "iepId": iepId,
                                    "type": 'TEXT',
                                    "content": e.target.value,
                                    "remarks": ""
                                };
                                handleChange(o.materialQuestionId, obj)
                            }}
                        />
                    </Box>
                    <Box>
                        <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">{t('responsible')}</Text>
                        <Textarea
                            bg="white"
                            fontSize="md"
                            minH="150px"
                            isDisabled={isCompleted || !canAddStudent()}
                            _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                            value={bulkAnswers.get(o.responsibleQuestionId) ? bulkAnswers.get(o.responsibleQuestionId).content : ''}
                            onChange={(e) => {
                                const obj = {
                                    "questionId": o.responsibleQuestionId,
                                    "iepId": iepId,
                                    "type": 'TEXT',
                                    "content": e.target.value,
                                    "remarks": ""
                                };
                                handleChange(o.responsibleQuestionId, obj)
                            }}
                        />
                    </Box>
                    <Box>
                        <Text fontSize="sm" fontWeight="bold" mb={2} color="gray.600">{t('communication')}</Text>
                        <Textarea
                            bg="white"
                            fontSize="md"
                            minH="150px"
                            isDisabled={isCompleted || !canAddStudent()}
                            _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                            value={bulkAnswers.get(o.communicationStrategyQuestionId) ? bulkAnswers.get(o.communicationStrategyQuestionId).content : ''}
                            onChange={(e) => {
                                const obj = {
                                    "questionId": o.communicationStrategyQuestionId,
                                    "iepId": iepId,
                                    "type": 'TEXT',
                                    "content": e.target.value,
                                    "remarks": ""
                                };
                                handleChange(o.communicationStrategyQuestionId, obj)
                            }}
                        />
                    </Box>
                </SimpleGrid>
                <Flex direction="column" gap={2} pt={5}>
                    {!isCompleted && canAddStudent() && (
                        <IconButton
                            size="sm"
                            isRound
                            variant="ghost"
                            colorScheme="red"
                            aria-label="Delete Objective"
                            icon={<Icon as={MdDelete} />}
                            onClick={() => {
                                setIsDelete(o.objectiveQuestionId);
                                onOpen();
                            }}
                        />
                    )}
                    {o.containsPreviousObjectives && (
                        <IconButton
                            size="sm"
                            isRound
                            variant="ghost"
                            colorScheme="purple"
                            aria-label="View History"
                            icon={<Icon as={MdHistory} />}
                            onClick={() => {
                                onGetVersionHistory(o.shiftedObjectiveId);
                                onOpenHistory();
                            }}
                        />
                    )}
                </Flex>
            </Flex>
        </AccordionPanel>
    </AccordionItem>
);

export default function GoalsAndObjectivesView({ goalsAndObjectives, iepId, onGetData, isCompleted, reviewStep, goalId, onUpdateObjetives }) {
    const toast = useToast()

    const { t } = useTranslation('iep');
    const [bulkAnswers, setBulkAnswers] = useState(new Map());
    const [loadingObjectives, setLoadingObjectives] = useState(false);
    const [loadingGoal, setLoadingGoal] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isDelete, setIsDelete] = useState(undefined);
    const [deleteGoal, setIsDeleteGoal] = useState(undefined);
    const { isOpen: isOpenHistory, onOpen: onOpenHistory, onClose: onCloseHistory } = useDisclosure()
    const [loadingHistory, setLoadingHistory] = useState(false);
    const [historyRes, setHistoryRest] = useState([]);


    const btnRef = React.useRef(null)
    const onGetVersionHistory = async (id) => {
        try {
            setLoadingHistory(true);
            onOpenHistory();
            const response = await onGetHistory(iepId, id);
            setHistoryRest(response.data);
            setLoadingHistory(false);
        } catch (e) {
            console.log(e);
            setLoadingHistory(false);
        }
    }

    const handleAddGoal = async () => {
        try {
            setLoadingGoal(true);
            await handleaAddBulkAnswers(false, false);
            await addNewGoal(iepId);
            toast({
                title: 'New Goal Added!!!',
                description: "New Goal Added Successfully",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
            await onGetData();
        } catch (e) {
            console.log(e)
            toast({
                title: 'Error!!!',
                description: "Could not add goal at the moment",
                status: 'error',
                duration: 3000,
                isClosable: true,
            });

        } finally {
            setLoadingGoal(false);
        }
    }
    const handleAddObjectives = async (goalQuestionID, quater) => {
        try {
            setLoadingObjectives(true);
            await handleaAddBulkAnswers(false, false);
            await addNewObjectives(iepId, goalQuestionID, quater);
            await onGetData();
            toast({
                title: 'Success!!',
                description: "Objectives Added Successfully",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
        } catch (e) {
            console.log(e)
            toast({
                title: 'Error!!',
                description: "Objectives Could not be added at the moment",
                status: 'error',
                duration: 3000,
                isClosable: true,
            })
        } finally {
            setLoadingObjectives(false);
        }
    }

    const handleaAddBulkAnswers = async (showtoast, refresh = true) => {
        try {
            setLoading(true);
            await addBulkAnswers([...bulkAnswers.values()]);
            if (refresh) await onGetData();
            if (showtoast) {
                toast({
                    title: 'Step Saved',
                    description: "Goal and Objective Step Saved",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
            }
        } catch (e) {
            console.log(e)
            if (showtoast) {
                toast({
                    title: 'Error!!!',
                    description: "Could Not Save Goal and Objective Step",
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
            }
        } finally {
            setLoading(false);
        }
    }

    const handleChange = (key, value) => {
        setBulkAnswers((prev) => {
            const newMap = new Map(prev);
            newMap.set(key, value);
            return newMap;
        })
    }

    const setBulkAnswerValue = React.useCallback(() => {
        if (Object.keys(goalsAndObjectives).length !== 0) {
            let map = new Map();
            goalsAndObjectives.firstQuarterGoals.forEach((goal) => {
                const areaContent = goal?.area?.answer?.content || 'Basic';
                if (goal.area) {
                    const obj = {
                        "questionId": goal.area.questionId,
                        "iepId": iepId,
                        "type": goal.area.type,
                        "content": areaContent,
                        "remarks": ""
                    };
                    map.set(goal.area.questionId, obj)
                }

                const subAreaContent = goal?.subArea?.answer?.content || (areaContent === 'Basic' ? 'Independence Skills' : '');
                if (goal.subArea && subAreaContent) {
                    const objSubArea = {
                        "questionId": goal.subArea.questionId,
                        "iepId": iepId,
                        "type": goal.subArea.type,
                        "content": subAreaContent,
                        "remarks": ""
                    };
                    map.set(goal.subArea.questionId, objSubArea)
                }

                if (goal?.goal?.answer?.content) {
                    const objGoal = {
                        "questionId": goal.goal.questionId,
                        "iepId": iepId,
                        "type": goal.goal.type,
                        "content": goal.goal.answer.content,
                        "remarks": goalId === undefined ? "" : goal.goal.questionId
                    };
                    map.set(goal.goal.questionId, objGoal)
                }


                goal.objectives.forEach((o) => {
                    if (o.objectiveAnswer?.content) {
                        const objective = {
                            "questionId": o.objectiveQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.objectiveAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.objectiveQuestionId, objective)
                    }
                    if (o.activityAnswer?.content) {
                        const activity = {
                            "questionId": o.activityQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.activityAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.activityQuestionId, activity)
                    }
                    if (o.materialAnswer?.content) {
                        const material = {
                            "questionId": o.materialQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.materialAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.materialQuestionId, material)
                    }
                    if (o.responsibleAnswer?.content) {
                        const responsible = {
                            "questionId": o.responsibleQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.responsibleAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.responsibleQuestionId, responsible)
                    }
                    if (o.communicationStrategyAnswer?.content) {
                        const responsible = {
                            "questionId": o.communicationStrategyQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.communicationStrategyAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.communicationStrategyQuestionId, responsible)
                    }
                })
            });
            goalsAndObjectives.secondQuarterGoals.forEach((goal) => {
                goal.objectives.forEach((o) => {
                    if (o.objectiveAnswer?.content) {
                        const objective = {
                            "questionId": o.objectiveQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.objectiveAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.objectiveQuestionId, objective)
                    }
                    if (o.activityAnswer?.content) {
                        const activity = {
                            "questionId": o.activityQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.activityAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.activityQuestionId, activity)
                    }
                    if (o.materialAnswer?.content) {
                        const material = {
                            "questionId": o.materialQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.materialAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.materialQuestionId, material)
                    }
                    if (o.responsibleAnswer?.content) {
                        const responsible = {
                            "questionId": o.responsibleQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.responsibleAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.responsibleQuestionId, responsible)
                    }
                    if (o.communicationStrategyAnswer?.content) {
                        const responsible = {
                            "questionId": o.communicationStrategyQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.communicationStrategyAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.communicationStrategyQuestionId, responsible)
                    }
                })
            });
            goalsAndObjectives.thirdQuarterGoals.forEach((goal) => {
                goal.objectives.forEach((o) => {
                    if (o.objectiveAnswer?.content) {
                        const objective = {
                            "questionId": o.objectiveQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.objectiveAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.objectiveQuestionId, objective)
                    }
                    if (o.activityAnswer?.content) {
                        const activity = {
                            "questionId": o.activityQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.activityAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.activityQuestionId, activity)
                    }
                    if (o.materialAnswer?.content) {
                        const material = {
                            "questionId": o.materialQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.materialAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.materialQuestionId, material)
                    }
                    if (o.responsibleAnswer?.content) {
                        const responsible = {
                            "questionId": o.responsibleQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.responsibleAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.responsibleQuestionId, responsible)
                    }
                    if (o.communicationStrategyAnswer?.content) {
                        const responsible = {
                            "questionId": o.communicationStrategyQuestionId,
                            "iepId": iepId,
                            "type": 'TEXT',
                            "content": o.communicationStrategyAnswer?.content,
                            "remarks": goalId === undefined ? "" : goal.goal.questionId
                        };
                        map.set(o.communicationStrategyQuestionId, responsible)
                    }
                })
            });
            setBulkAnswers(map);
        }
    }, [goalsAndObjectives, iepId, goalId]);

    useEffect(() => {
        setBulkAnswerValue();
    }, [setBulkAnswerValue])
    const handleClose = () => {
        setIsDelete(undefined);
        setIsDeleteGoal(false);
        onClose();


    }
    const onCompleteIEP = async () => {
        try {
            setLoading(true)
            if (isDelete) {
                if (deleteGoal) {
                    await deleteQuestionGoal(isDelete);
                } else {
                    await deleteQuestionObjectives(isDelete);
                }
                handleClose();

                toast({
                    title: 'Delete',
                    description: "Deleted Succesfully",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
            } else {
                await completeIEPStep(iepId, 3, !isCompleted);
                toast({
                    title: 'Step Completed',
                    description: "Goal and Objective Step Completed",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                navigate(-1);
            }

            await onGetData();
        } catch (e) {
            if (isDelete) {
                toast({
                    title: 'Error',
                    description: "Could not delete",
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
                setIsDelete(undefined);
            } else {
                toast({
                    title: 'Error',
                    description: "Goal and Objective Could not be completed !",
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
            }
        } finally {
            setLoading(false);
            handleClose();
        }


    }

    const shouldBeVisiblae = (currentGoalId) => {
        if (goalId === undefined) {
            return true;
        }
        if (goalId === currentGoalId) {
            return true;
        }
        return false;
    }
    const onReviewHistory = () => {
        onUpdateObjetives(bulkAnswers);

    }


    const onGetSubArea = (qID) => {
        const data = bulkAnswers.get(qID);
        if (data) {
            const view = [];
            if (data.content === 'Basic') {
                ['Independence Skills', 'Gross Motors Skills', 'Fine Motor Skills', 'Social Skills', 'Emotional Skills', 'Communication Skills'].forEach((v) => {
                    view.push(<option key={v} value={v}>{v}</option>)
                })
                return view;
            }
            if (data.content === 'Language') {
                ['Pre learning', 'Reading Skills'].forEach((v) => {
                    view.push(<option key={v} value={v}>{v}</option>)
                })
                return view;
            }
            if (data.content === 'Maths') {
                ['Math Skills'].forEach((v) => {
                    view.push(<option key={v} value={v}>{v}</option>)
                })
                return view;
            }
            if (data.content === 'Others') {
                ['Other Skills'].forEach((v) => {
                    view.push(<option key={v} value={v}>{v}</option>)
                })
                return view;
            }
        }
        return null;
    }



    return (
        <Box mt={'24px'}>
            {goalId === undefined && (
                <Flex justify={'space-between'} align="center" mb={6} pb={4} borderBottom="1px solid" borderColor="gray.100">
                    <Box>
                        <Text fontWeight={'900'} fontSize={{ base: '20px', md: '24px' }} color="blue.600">
                            {t('step3')} : {t('step3Title')}
                        </Text>
                    </Box>
                    <Button
                        leftIcon={<Icon as={MdAdd} />}
                        colorScheme='blue'
                        variant='solid'
                        onClick={handleAddGoal}
                        isLoading={loadingGoal}
                        isDisabled={loadingGoal || isCompleted || !canAddStudent()}
                        borderRadius="xl"
                        boxShadow="md"
                        _hover={{ transform: 'translateY(-1px)', boxShadow: 'lg' }}
                    >
                        {t('addGoal')}
                    </Button>
                </Flex>
            )}

            {Object.keys(goalsAndObjectives).length !== 0 && (
                <Box>
                    <Accordion defaultIndex={[0]} allowMultiple>
                        {goalsAndObjectives?.firstQuarterGoals?.map((v, index) =>
                            shouldBeVisiblae(v?.goal?.questionId) &&
                            <AccordionItem key={v?.goal?.questionId || index} border="none" mb={4}>
                                <Card variant="outline" borderRadius="xl" overflow="hidden" boxShadow="sm" border="1px solid" borderColor="gray.100">
                                    <h2>
                                        <AccordionButton p={4} _hover={{ bg: 'gray.50' }} _expanded={{ bg: 'blue.50' }}>
                                            <Box as="span" flex='1' textAlign='left' fontWeight={800} color="gray.700" fontSize="lg">
                                                Goal {index + 1}: {v.goal && bulkAnswers.get(v.goal.questionId) ? bulkAnswers.get(v.goal.questionId).content.substring(0, 50) + '...' : 'New Goal'}
                                            </Box>
                                            {!goalId && (
                                                <IconButton
                                                    size="sm"
                                                    variant='ghost'
                                                    colorScheme='red'
                                                    aria-label='Delete Goal'
                                                    isLoading={loadingObjectives}
                                                    isDisabled={loadingObjectives || isCompleted || !canAddStudent()}
                                                    icon={<Icon as={MdDelete} />}
                                                    mr={3}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setIsDelete(v.goal.questionId);
                                                        setIsDeleteGoal(true);
                                                        onOpen();
                                                    }}
                                                />
                                            )}
                                            <AccordionIcon />
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={6} px={4}>
                                        {!goalId && (
                                            <Box bg="blue.50" p={5} borderRadius="xl" border="1px solid" borderColor="blue.100" mb={6}>
                                                <Grid templateColumns={{ base: '1fr', lg: '30% 1fr' }} gap={6}>
                                                    <GridItem>
                                                        <Stack spacing={4}>
                                                            <Box>
                                                                <Text fontWeight="700" mb={2} fontSize="md" color="blue.700" textTransform="uppercase">{t('area')}</Text>
                                                                {v.area && (
                                                                    <Select
                                                                        bg="white"
                                                                        borderRadius="lg"
                                                                        isDisabled={isCompleted || !canAddStudent()}
                                                                        _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                                                                        value={bulkAnswers.get(v.area.questionId) ? bulkAnswers.get(v.area.questionId).content : ''}
                                                                        onChange={(e) => {
                                                                            const obj = {
                                                                                "questionId": v.area.questionId,
                                                                                "iepId": iepId,
                                                                                "type": v.area.type,
                                                                                "content": e.target.value,
                                                                                "remarks": ""
                                                                            };
                                                                            handleChange(v.area.questionId, obj)
                                                                        }}
                                                                    >
                                                                        {['Basic', 'Language', 'Maths', 'Others'].map((l) =>
                                                                            <option key={l} value={l}>{l}</option>
                                                                        )}
                                                                    </Select>
                                                                )}
                                                            </Box>
                                                            <Box>
                                                                <Text fontWeight="700" mb={2} fontSize="md" color="blue.700" textTransform="uppercase">{t('subArea')}</Text>
                                                                {v.subArea && (
                                                                    <Select
                                                                        bg="white"
                                                                        borderRadius="lg"
                                                                        isDisabled={isCompleted || !canAddStudent() || !bulkAnswers.get(v.area.questionId)}
                                                                        _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                                                                        value={bulkAnswers.get(v.subArea.questionId) ? bulkAnswers.get(v.subArea.questionId).content : ''}
                                                                        onChange={(e) => {
                                                                            const obj = {
                                                                                "questionId": v.subArea.questionId,
                                                                                "iepId": iepId,
                                                                                "type": v.subArea.type,
                                                                                "content": e.target.value,
                                                                                "remarks": ""
                                                                            };
                                                                            handleChange(v.subArea.questionId, obj)
                                                                        }}
                                                                    >
                                                                        {onGetSubArea(v.area.questionId)}
                                                                    </Select>
                                                                )}
                                                            </Box>
                                                        </Stack>
                                                    </GridItem>
                                                    <GridItem>
                                                        <Text fontWeight="700" mb={2} fontSize="md" color="blue.700" textTransform="uppercase">{t('goal')}</Text>
                                                        {v.goal && (
                                                            <Textarea
                                                                bg="white"
                                                                borderRadius="lg"
                                                                minH="200px"
                                                                fontSize="md"
                                                                isDisabled={isCompleted || !canAddStudent()}
                                                                _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                                                                value={bulkAnswers.get(v.goal.questionId) ? bulkAnswers.get(v.goal.questionId).content : ''}
                                                                onChange={(e) => {
                                                                    const obj = {
                                                                        "questionId": v.goal.questionId,
                                                                        "iepId": iepId,
                                                                        "type": v.goal.type,
                                                                        "content": e.target.value,
                                                                        "remarks": ""
                                                                    };
                                                                    handleChange(v.goal.questionId, obj)
                                                                }}
                                                            />
                                                        )}
                                                    </GridItem>
                                                </Grid>
                                            </Box>
                                        )}

                                        {/* Quarter Sections */}
                                        <Box mt={4}>
                                            {/* First Quarter */}
                                            {reviewStep === 0 && (
                                                <Box mb={6}>
                                                    <Flex justify="space-between" align="center" mb={4}>
                                                        <Heading size="sm" color="blue.600">{t('objectFristQtr')}</Heading>
                                                        <IconButton
                                                            size="sm"
                                                            colorScheme="teal"
                                                            isRound
                                                            icon={<Icon as={MdAdd} />}
                                                            isLoading={loadingObjectives}
                                                            isDisabled={loadingObjectives || isCompleted || !canAddStudent()}
                                                            onClick={() => handleAddObjectives(v?.goal?.questionId, 1)}
                                                        />
                                                    </Flex>
                                                    <Accordion allowMultiple defaultIndex={[0]}>
                                                        {v.objectives?.map((o, objIndex) => (
                                                            <ObjectiveForm
                                                                key={o.objectiveQuestionId}
                                                                index={objIndex + 1}
                                                                o={o}
                                                                isCompleted={isCompleted}
                                                                bulkAnswers={bulkAnswers}
                                                                iepId={iepId}
                                                                t={t}
                                                                setIsDelete={setIsDelete}
                                                                onOpen={onOpen}
                                                                onGetVersionHistory={onGetVersionHistory}
                                                                onOpenHistory={onOpenHistory}
                                                                handleChange={handleChange}
                                                            />
                                                        ))}
                                                    </Accordion>
                                                </Box>
                                            )}

                                            {/* Second Quarter */}
                                            {(reviewStep === 0 || reviewStep === 4) && (
                                                <Box mb={6}>
                                                    <Flex justify="space-between" align="center" mb={4}>
                                                        <Heading size="sm" color="blue.600">{t('objectiveSecondQtr')}</Heading>
                                                        <IconButton
                                                            size="sm"
                                                            colorScheme="teal"
                                                            isRound
                                                            icon={<Icon as={MdAdd} />}
                                                            isLoading={loadingObjectives}
                                                            isDisabled={loadingObjectives || isCompleted || !canAddStudent()}
                                                            onClick={() => handleAddObjectives(v?.goal?.questionId, 2)}
                                                        />
                                                    </Flex>
                                                    <Accordion allowMultiple defaultIndex={[0]}>
                                                        {goalsAndObjectives?.secondQuarterGoals[index]?.objectives?.map((o, objIndex) => (
                                                            <ObjectiveForm
                                                                key={o.objectiveQuestionId}
                                                                index={objIndex + 1}
                                                                o={o}
                                                                isCompleted={isCompleted}
                                                                bulkAnswers={bulkAnswers}
                                                                iepId={iepId}
                                                                t={t}
                                                                setIsDelete={setIsDelete}
                                                                onOpen={onOpen}
                                                                onGetVersionHistory={onGetVersionHistory}
                                                                onOpenHistory={onOpenHistory}
                                                                handleChange={handleChange}
                                                            />
                                                        ))}
                                                    </Accordion>
                                                </Box>
                                            )}

                                            {/* Third Quarter */}
                                            <Box mb={6}>
                                                <Flex justify="space-between" align="center" mb={4}>
                                                    <Heading size="sm" color="blue.600">Objectives For Third Quarter</Heading>
                                                    <IconButton
                                                        size="sm"
                                                        colorScheme="teal"
                                                        isRound
                                                        icon={<Icon as={MdAdd} />}
                                                        isLoading={loadingObjectives}
                                                        isDisabled={loadingObjectives || isCompleted || !canAddStudent()}
                                                        onClick={() => handleAddObjectives(v?.goal?.questionId, 3)}
                                                    />
                                                </Flex>
                                                <Accordion allowMultiple defaultIndex={[0]}>
                                                    {goalsAndObjectives?.thirdQuarterGoals[index]?.objectives?.map((o, objIndex) => (
                                                        <ObjectiveForm
                                                            key={o.objectiveQuestionId}
                                                            index={objIndex + 1}
                                                            o={o}
                                                            isCompleted={isCompleted}
                                                            bulkAnswers={bulkAnswers}
                                                            iepId={iepId}
                                                            t={t}
                                                            setIsDelete={setIsDelete}
                                                            onOpen={onOpen}
                                                            onGetVersionHistory={onGetVersionHistory}
                                                            onOpenHistory={onOpenHistory}
                                                            handleChange={handleChange}
                                                        />
                                                    ))}
                                                </Accordion>
                                            </Box>
                                        </Box>
                                    </AccordionPanel>
                                </Card>
                            </AccordionItem>
                        )}
                    </Accordion>

                    <Flex mt={'32px'} direction={{ base: 'column', md: 'row' }} gap={4} justifyContent={'flex-end'}>
                        {!goalId ? (
                            <>
                                <GhostButton size='lg' onClick={() => navigate(-1)}>
                                    {t('back')}
                                </GhostButton>
                                {!isCompleted && (
                                    <BrandButton
                                        size='lg'
                                        onClick={() => handleaAddBulkAnswers(true)}
                                        isLoading={loading}
                                        isDisabled={loading}
                                    >
                                        {t('save')}
                                    </BrandButton>
                                )}
                                <BrandButton
                                    size='lg'
                                    onClick={() => onOpen()}
                                    isDisabled={!canAddStudent()}
                                >
                                    {isCompleted ? t('redoStep') : t('completeStep')}
                                </BrandButton>
                            </>
                        ) : (
                            <BrandButton size='lg' onClick={() => onReviewHistory()}>
                                Update
                            </BrandButton>
                        )}
                    </Flex>
                </Box>
            )}

            <CoustomAlertDialog
                onClose={handleClose}
                onOpen={onOpen}
                isOpen={isOpen}
                onMainAction={onCompleteIEP}
                loading={loading}
                warning={isDelete ? false : true}
            />

            {isOpenHistory && (
                <Modal
                    onClose={onCloseHistory}
                    finalFocusRef={btnRef}
                    isOpen={isOpenHistory}
                    scrollBehavior={'inside'}
                    size={'6xl'}
                >
                    <ModalOverlay />
                    <ModalContent borderRadius="2xl">
                        <ModalHeader borderBottom="1px solid" borderColor="gray.100">Version History</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody p={0}>
                            {loadingHistory ? (
                                <Stack p={6} spacing={4}>
                                    <Skeleton height='40px' borderRadius="md" />
                                    <Skeleton height='40px' borderRadius="md" />
                                    <Skeleton height='40px' borderRadius="md" />
                                </Stack>
                            ) : (
                                <Box overflowX="auto">
                                    <Box minW="1000px">
                                        <Flex bg="blue.600" p={4} color="white" fontWeight="bold">
                                            <Text w={'20%'}>Objectives</Text>
                                            <Text w={'20%'} ml={'12px'}>Activities</Text>
                                            <Text w={'16%'} ml={'12px'}>Materials</Text>
                                            <Text w={'16%'} ml={'12px'}>Responsible</Text>
                                            <Text w={'14%'} ml={'12px'}>Created</Text>
                                            <Text w={'14%'} ml={'12px'}>Revised</Text>
                                        </Flex>
                                        {historyRes.length > 0 ? (
                                            historyRes.map((i, index) => (
                                                <Flex key={index} p={4} borderBottom="1px solid" borderColor="gray.100" bg={index % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: 'blue.50' }} align="center">
                                                    <Box w={'20%'}>
                                                        <Badge colorScheme="blue" mb={1} borderRadius="full" px={2}>Version {i.version}</Badge>
                                                        <Text fontSize="sm" fontWeight="medium">{i.objective}</Text>
                                                    </Box>
                                                    <Text fontSize="sm" w={'20%'} ml={'12px'}>{i.activity}</Text>
                                                    <Text fontSize="sm" w={'16%'} ml={'12px'}>{i.material}</Text>
                                                    <Text fontSize="sm" w={'16%'} ml={'12px'}>{i.responsible}</Text>
                                                    <Box w={'14%'} ml={'12px'}>
                                                        <Text fontSize="xs" color="gray.500">Created</Text>
                                                        <Text fontSize="sm">{new Date(i.created).toLocaleDateString()}</Text>
                                                    </Box>
                                                    <Box w={'14%'} ml={'12px'}>
                                                        <Text fontSize="xs" color="gray.500">Revised</Text>
                                                        <Text fontSize="sm">{new Date(i.answeredTimestamp).toLocaleDateString()}</Text>
                                                    </Box>
                                                </Flex>
                                            ))
                                        ) : (
                                            <Box p={10} textAlign="center">
                                                <Text color="gray.500">No history found for this objective.</Text>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            )}
                        </ModalBody>
                        <ModalFooter borderTop="1px solid" borderColor="gray.100">
                            <Button variant="ghost" onClick={onCloseHistory}>Close</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            )}
        </Box>
    )
}
